import axiosHttp from "services/axiosHttp";
const { createSlice, createAsyncThunk } = require("@reduxjs/toolkit");

// Real backend confirmed live. Matches asset.controller/service exactly:
// GET /assets -> { content, total, page, size } — normalized below into
// { docs, pagination: { page, total } } so the rest of this module (pagination
// component, etc.) doesn't need restructuring.
export const fetchAssetList = createAsyncThunk("fetchAssetList", async ({ page, limit, filters }) => {
	const params = new URLSearchParams({
		page: page,
		size: limit,
	});

	// Only append filters that actually have a value — backend does
	// `if (rest.status) where.status = ...` etc, so it's safe to omit,
	// but sending status="" could still be picked up as truthy in some
	// query-parsing setups, so we strip empty ones defensively.
	const optionalParams = {
		keyword: filters?.keyword,
		status: filters?.status,
		assetTypeId: filters?.assetTypeId,
		categoryId: filters?.categoryId,
		companyId: filters?.companyId,
		departmentId: filters?.departmentId,
		locationId: filters?.locationId,
		premisesId: filters?.premisesId,
		assetLocationId: filters?.assetLocationId,
		brandId: filters?.brandId,
		allocatedUserId: filters?.allocatedUserId,
		warrantyExpiringWithinDays: filters?.warrantyExpiringWithinDays,
	};
	Object.entries(optionalParams).forEach(([key, value]) => {
		if (value !== undefined && value !== null && value !== "") {
			params.set(key, value);
		}
	});

	const response = await axiosHttp.get(`assets?${params}`);
	const data = response.data?.data ?? response.data;

	return {
		docs: data.content ?? [],
		pagination: { page: data.page, total: data.total },
	};
});

const AssetListSlice = createSlice({
	name: "assetListSlice",
	initialState: {
		isLoading: false,
		data: null,
		error: null,
		page: 1,
		total: 0,
	},
	extraReducers: (builder) => {
		builder.addCase(fetchAssetList.pending, (state) => {
			state.isLoading = true;
		});
		builder.addCase(fetchAssetList.fulfilled, (state, action) => {
			state.isLoading = false;
			state.data = action.payload;
			state.page = action.payload.pagination?.page;
			state.total = action.payload.pagination?.total;
		});
		builder.addCase(fetchAssetList.rejected, (state, action) => {
			state.isLoading = false;
			state.error = action.payload;
		});
	},
});

export default AssetListSlice.reducer;